<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #layoutContent>
      <Loader :is-loading="isLoading">
        <div class="row px-5 mb-5">
          <ActionsBar :query="query" :handleRangeDate="handleRangeDate" :contacts="contacts" :status="invoiceStatus" id="invoice-datepicker"/>
        </div>

        <div class="row d-flex flex-wrap px-5">
          <div class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
            <div class="d-flex flex-grow-1">
              <table class="table  fs-6 fw-bold gs-0 gy-2 m-0 mb-5" style="border-radius: 8px;">
                <tbody>
                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-4">
                    <h3 class="fs-1 ">{{$t('invoice.label.recurrent.Configuration')}}</h3>
                  </td>
                  <td class="px-5 py-6 text-end pe-5">
                    <Button v-if="$can(abilities.UPDATE_RECURRING_INVOICE) || $can(abilities.UPDATE_ALL_RECURRING_INVOICE)" type="new" btn-class="btn-sm" v-show="currentInvoice.status != 'completed' "  btn-text="appointments.update" @click="goToUpdate"></Button>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.startDate') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{ formatDate(currentInvoice.recurring_date) }}</span>
                  </td>
                </tr>

                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.next_recurring_date') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{ formatDate(currentInvoice.next_recurring_at) }}</span>
                  </td>
                </tr>


                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.frequency') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary"> {{ $t('invoice.label.recurrent.every') }} {{ currentInvoice.frequency_count }} {{ getRecurrentFrequencyName(currentInvoice.frequency) }} </span>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #CCCFD3;" v-if=" currentInvoice.limit_count">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.repeat') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{ currentInvoice.limit_count}} {{ $t('invoice.label.recurrent.time') }}</span>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.endDate') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{ formatDate(currentInvoice.limit_date) }}</span>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #CCCFD3;">
                  <td class="px-5 py-5 text-gray-400">{{ $t('invoice.label.recurrent.status') }}</td>
                  <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{ getRecurrentInvoiceStatusName(currentInvoice.status) }}</span>
                  </td>
                </tr>


                </tbody>
              </table>
            </div>

          </div>
          <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">

            <Card :title="$t('invoice.list')" containerClass="mb-5 mt-5 px-8">
              <template #cardBody>
                <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                      id="invoices_datatable">
                  <thead class="mb-5">
                  <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                    <th class="min-w-100px text-center">{{ $t('invoice.label.date') }}</th>
                    <th class="min-w-100px text-center">{{ $t('invoice.label.number') }}</th>
                    <th class="min-w-100px text-center">{{ $t('invoice.label.customer') }}</th>
                    <th class="min-w-100px text-center">{{ $t('invoice.label.status') }} </th>
                    <th class="min-w-100px text-center">{{ $t('invoice.label.totalAmount') }}</th>
                    <th class="w-100px text-start">{{ $t('label.action') }}</th>
                  </tr>
                  </thead>
                </table>
              </template>
            </Card>
          </div>
        </div>
      </Loader>
    </template>
  </SubLayout>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {formattedLocalAmount,formatDate} from "@/mixins/Helpers";
import {useRoute, useRouter} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import ActionsBar from "@/views/Invoice/components/ActionsBar.vue";
import Card from "@/Modules/CRM/components/Card";
import Button from "@/components/Button";
import abilities from "@/composables/abilities";
import Loader from "@/components/Loader.vue"

const route = useRoute()

const router = useRouter()
const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()

const title = ref("breadcrumbs.recurrent.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.recurrent.list',
    route: 'recurrent-invoices',
    params: {}
  },
  {
    name: 'breadcrumbs.recurrent.detail',
    route: 'recurrent-invoices-view',
    params: { id: route.params.id }
  }
])

const table = ref()
const query = ref({
  status: 'all',
  contact: 'all',
  start_date: '',
  end_date: ''
})
const isLoading = ref(true)

const invoiceStatus = computed(() => store.getters['invoices/invoiceStatus'])
const recurringInvoiceStatus = computed(() => store.getters['invoices/recurringInvoiceStatus'])
const contacts = computed(() => store.getters['contacts/getContacts'])
const currentInvoice = computed(() => store.getters['invoices/currentRecurrentInvoice'])
const frequencyEnum = computed(() => store.getters["invoices/recurringInvoiceFrequency"])

watch(() => locale.value, (value) => {
  nextTick(() => fetchDatas() )
}, { deep: true })


watch(() => isLoading.value, (value) => {
  if(!value){
    nextTick(() => fetchDatas())
  }
}, { deep: true })

watch(() => query.value.status, (newValue) => {
  table.value.ajax.url(`${BASE_URL}/get/invoices/datatables?status=${query.value.status}&contact=${query.value.contact}&startDate=${query.value.start_date}&endDate=${query.value.end_date}&recurring_invoice_id=${route.params.id}`).load()
})

watch(() => query.value.contact, (newValue) => {
  table.value.ajax.url(`${BASE_URL}/get/invoices/datatables?status=${query.value.status}&contact=${query.value.contact}&startDate=${query.value.start_date}&endDate=${query.value.end_date}&recurring_invoice_id=${route.params.id}`).load()
})


watch(() => [query.value.start_date, query.value.end_date], (newValue) => {
  table.value.ajax.url(`${BASE_URL}/get/invoices/datatables?status=${query.value.status}&contact=${query.value.contact}&startDate=${query.value.start_date}&endDate=${query.value.end_date}&recurring_invoice_id=${route.params.id}`).load()
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#invoices_datatable").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'desc']],
    ajax: {
      url: BASE_URL + `/get/invoices/datatables?status=${query.value.status}&contact=${query.value.contact}&startDate=${query.value.start_date}&endDate=${query.value.end_date}&recurring_invoice_id=${route.params.id}`,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [
      { data: "date" }, { data: "invoice_number" }, { data: "contact" }, { data: "invoice_status" }, { data: "total" }, { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [

      {
        targets: -6,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -5,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },

      {
        targets: -4,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },

      {
        targets: -3,
        orderable: false,
        className: "dt-center text-center" ,
        render: function (t, a, e, l) {
          let status = getInvoiceStatusName(t)
          const locale = i18n.global.locale.value
          let color = status.color
          status = status[locale]
          return '<span class="badge badge-light-' + color +'" style="font-size:13px; margin:3px; padding:5px"><span style="margin-left: 5px" class="valueRow' + l.row + ' label label-success label-inline font-weight-bolder mr-2 edit_value_btn">' + status + '</span></span>'
        },
      },
      {
        targets: -2,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + formattedLocalAmount(t) + ' ' + currentInvoice.value?.currency?.symbol + "</span>";
        },
      },
      {
        width: "10%",
        targets: -1,
        "className": "dt-center text-start",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""
          if(can('invoice_view')){
            render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon show_btn" title="'+ i18n.global.t('button.show') +'"><i  data-id="'+ e.id +'" class="fas fa-eye fs-2"></i></a>'
          }
          if(can('invoice_update')) {
            if(e.invoice_status == 'DRAFT'){
              render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i  data-id="'+ e.id +'" class="fas fa-edit fs-2"  style="color: ${Theme.gray}"></i></a>'
            }
          }
          if(false){
            render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: ${Theme.gray}"></i></a>'
          }

          return render
        },
      },

    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#invoices_datatable .show_btn", (e) => {
    router.push({ name: 'invoices-view', params: { id: e.target.getAttribute('data-id') } })
  });

  $(document).on("click", "#invoices_datatable .edit_btn", (e) => {
    router.push({ name: 'invoices-edit', params: { id: e.target.getAttribute('data-id') } })
  });

}

function getInvoiceStatusName(status) {
  const {color, fr, en} = invoiceStatus.value.find(el => el.value === status) || ''
  return {color, fr, en}
}
function getRecurrentInvoiceStatusName(status) {
  const {color, fr, en} = recurringInvoiceStatus.value?.find(el => el.value === status) || ''
  return locale.value == "fr" ? fr : en
}

function getRecurrentFrequencyName(status) {
  const {color, fr, en} = frequencyEnum.value?.find(el => el.value === status) || ''
  return locale.value == "fr" ? fr : en
}

const loadCurrentRecurringInvoice = async () => {
  if(route.params.id){
    await store.dispatch('invoices/getRecurrentInvoiceById', route.params.id) 
  }
}

function loadData() {
  Promise.all([
    store.dispatch('invoices/loadInvoiceStatus'),
    store.dispatch('invoices/loadRecurrentInvoiceStatus'),
    store.dispatch('contacts/loadContacts'),
    store.dispatch('invoices/loadRecurringInvoiceFrequency'),
    loadCurrentRecurringInvoice(),
    fetchDatas()
  ]).finally(() => {
    isLoading.value = false
  })
}
function goToUpdate(){
  router.push({name: 'recurrent-invoices-edit', params: {id: route.params.id}})
}
onMounted( () => {
  loadData()
})

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}

function openCreateView(){
  router.push({ name: 'invoices-create' })
}
</script>

<style scoped>

</style>
